// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"742":"fbcc3f9f","839":"0efd9436"}[chunkId] + ".css";
};